import { ContactMessage } from "../../../../lib/service/client/FrontMessageService";
import React, { FC } from "react";
import { toDateFormat } from "../../../../lib/util";
import { MessageText } from "components/admin/message/MessageText";
import styled from "styled-components";

const convertLinkedTextList = (message: string): { url: string | null; text: string }[] => {
  const lines: string[] = message.split("\n");
  return lines.map((line) => {
    const matched = line.match(/(http(s)?:\/\/.+)$/);
    if (matched && matched.index !== -1) {
      return {
        text: line.slice(0, matched.index),
        url: line.slice(matched.index, line.length),
      };
    } else {
      return { text: line, url: null };
    }
  });
};

type AccountMessageAreaProps = {
  message: ContactMessage;
};
export const AccountMessageArea: FC<AccountMessageAreaProps> = (props: AccountMessageAreaProps) => {
  const linkedTextList = convertLinkedTextList(props.message.message);
  return (
    <div className="mypage_content_message_chat_area--item mypage_content_message_chat_area--item--client">
      <div className="mypage_content_message_chat_area--item_img">
        <svg width="0" height="0" style={{ position: "absolute", top: 0, left: 0 }}>
          <clipPath id="clip01">
            <polyline className="st0" points="30,0 30,25 25,30 0,30 0,0 30,0 " />
          </clipPath>
        </svg>
        <div className="mypage_content_message_chat_area--item_img_icon">
          <div className="mypage_content_message_chat_area--item_img_icon_border">
            <svg
              x="0px"
              y="0px"
              width="32px"
              enableBackground="new 0 0 32 32"
              height="32px"
              viewBox="0 0 32 32"
              style={{ overflow: "visible" }}
              xmlSpace="preserve"
            >
              <g>
                <path d="M31,1v25l-5,5H1V1H31 M32,0H0v32h26.4l5.6-5.6V0L32,0z" />
              </g>
            </svg>
          </div>
          <div className="mypage_content_message_chat_area--item_img_icon_main">
            <svg width="30" height="30" viewBox="0 0 30 30">
              <image
                xlinkHref="/img/profile_icon.png"
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid slice"
                clipPath="url(#clip01)"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="mypage_content_message_chat_area--item_text">
        <p>
          {linkedTextList.map((linkedText, index) => (
            <React.Fragment key={index}>
              {linkedText.text && <>{linkedText.text}</>}
              {linkedText.url && (
                <LinkText href={linkedText.url} target="_blank">
                  {linkedText.url}
                </LinkText>
              )}
              <br />
            </React.Fragment>
          ))}
        </p>
      </div>
      <p className="mypage_content_message_chat_area--item_date">{toDateFormat(props.message.sent_at)}</p>
    </div>
  );
};

const LinkText = styled.a`
  color: #0000ff;
  text-decoration: underline;
  cursor: pointer;
  line-break: anywhere;
`;

type MemberMessageAreaProps = {
  message: ContactMessage;
};
export const MemberMessageArea: FC<MemberMessageAreaProps> = (props: MemberMessageAreaProps) => {
  return (
    <div className="mypage_content_message_chat_area--item mypage_content_message_chat_area--item--customer">
      <div className="mypage_content_message_chat_area--item_text">
        <p>
          <MessageText message={props.message.message} />
        </p>
      </div>
      <p className="mypage_content_message_chat_area--item_date">{toDateFormat(props.message.sent_at)}</p>
    </div>
  );
};
